goog.provide("shadow.js.shim.module$ol$style$Icon$default");
shadow.js.shim.module$ol$style$Icon$default = shadow.js.require(191, {}).default;
